import React, { Component } from 'react';
import { connect } from 'shalala';
import { Badge } from 'react-bootstrap';

import { Event } from '../../../support';
import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';
import {
  ReceptoresListSectorPrimarioColumn,
  ReceptoresListSectorPrimarioRoleColumn,
} from './components/ReceptoresListSectorPrimarioColumns';

import { Guardian } from '@xaamin/guardian';

class ReceptoresList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selectedRowKeys: [],
    };

    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
  }

  get columns() {
    const sectorPrimarioColumns = Guardian.allows('sector_primario.access')
      ? [
          {
            key: 'sector_primario',
            title: 'Sector primario',
            dataIndex: 'sector_primario',
            align: 'center',
            render: (item) => <ReceptoresListSectorPrimarioColumn data={item} />,
          },

          {
            key: 'sector_primario_is_adquiriente',
            title: 'Rol',
            dataIndex: 'sector_primario_is_adquiriente',
            align: 'center',
            render: (item) => <ReceptoresListSectorPrimarioRoleColumn data={item} />,
          },
        ]
      : [];

    const common = [
      {
        key: 'rfc',
        title: 'RFC',
        dataIndex: 'rfc',
      },
      {
        key: 'razon_social',
        title: 'Razón social',
        dataIndex: 'razon_social',
      },
    ];

    return [
      ...common,
      ...sectorPrimarioColumns,
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        className: 'text-center',
        render: this.renderStatus,
      },
    ];
  }

  componentDidMount() {
    const { data } = this.props.list;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
  }

  renderStatus = (item) => {
    const { status } = item;

    let text = 'activating';
    let variant = 'info';

    switch (status) {
      case 1:
        text = 'active';
        variant = 'success';
        break;

      case -1:
        text = 'bloked';
        variant = 'danger';
        break;
      default:
        break;
    }

    return <Badge variant={variant}>{text}</Badge>;
  };

  paginate(meta) {
    const { filters = {} } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnAppNeedsRefresh = () => {
    this.paginate({ page: 1 });
  };

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selectedRowKeys: selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props.list;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  render() {
    const { onRowClick } = this.props;
    const { data, busy } = this.props.list;
    const { columns, selectedRowKeys } = this.state;

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={data}
        pagination={this.getPaginationConfig()}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          ...this.getRowSelectionConfig(),
        }}
        onRowClick={onRowClick}
        onRow={(item) => {
          return {
            className: item.highlight ? 'row-highlighted' : '',
          };
        }}
      ></Table>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.receptores.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.receptores.list };
};

export default connect(useStore, mapState, mapActions)(ReceptoresList);
